export const  TEAM_ROLES_LIST = [
    { id: 1, key: "TEAM_LEAD", value: "Team Lead" },
    { id: 2, key: "TEAM_MEMBER", value: "Team Member" },
  ];